import axios from 'axios';
import BaseCrud from './baseCrud';
const crud = new BaseCrud('content');

export const state = () => ({ ...crud.state, contents: [] });

export const getters = {
    ...crud.getters,

    contents: state => state.contents
};

export const mutations = {
    ...crud.mutations,

    SET_CONTENTS(state, contents) {
        state.contents = contents;
    }
};

export const actions = {
    ...crud.actions,

    async index({ getters, commit }) {
        if (getters.contents.length) {
            return getters.contents;
        }

        const content = await axios.$get('/admin/contents', {
            params: {
                noValue: true
            }
        });

        commit('SET_CONTENTS', content);

        return content;
    },

    async getGroups(vuexContext, { campusId = null, isCommon = false }) {
        const groups = await axios.$get('/admin/contents/about-us/groups', {
            params: { campusId, isCommon }
        });

        return groups;
    },

    async updateGroups(vuexContext, data) {
        await axios.$post('/admin/contents/about-us/groups', data);
    }
};
